import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import Container from "../base/Container";
import { UnitTestsPanel } from "./UnitTestsPanel";
import { RegressionTestsPanel } from "./RegressionTestsPanel";

type SubTab = "unit" | "regression";

export const TestSuitesContent: React.FC = () => {
  const [subTab, setSubTab] = useState<SubTab>("unit");

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>Test Suites</Typography>

      <Tabs value={subTab} onChange={(_, v) => setSubTab(v)} sx={{ mb: 2 }}>
        <Tab label="Unit & Integration Tests" value="unit" sx={{ textTransform: "none", fontWeight: 600 }} />
        <Tab label="Regression Tests" value="regression" sx={{ textTransform: "none", fontWeight: 600 }} />
      </Tabs>

      {subTab === "unit" ? <UnitTestsPanel /> : <RegressionTestsPanel />}
    </Box>
  );
};

const TestSuitesPage: React.FC = () => (
  <Container>
    <TestSuitesContent />
  </Container>
);

export default TestSuitesPage;
